import scoringTypeNotIn from "./scoringTypeNotIn.js";

const emptyArray = [];
const anyScoringType = function(session) {
    return scoringTypeNotIn(session, emptyArray);
};

export default anyScoringType;